'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SelectInputTag = require('./SelectInputTag');

var _SelectInputTag2 = _interopRequireDefault(_SelectInputTag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SelectInputTags = function (_PureComponent) {
  _inherits(SelectInputTags, _PureComponent);

  function SelectInputTags() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SelectInputTags);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SelectInputTags.__proto__ || Object.getPrototypeOf(SelectInputTags)).call.apply(_ref, [this].concat(args))), _this), _this.renderSelectedOption = function (option, i) {
      var _this$props = _this.props,
          stylingKey = _this$props.stylingKey,
          displayKey = _this$props.displayKey,
          onRemove = _this$props.onRemove;

      return _react2.default.createElement(_SelectInputTag2.default, {
        option: option,
        stylingKey: stylingKey,
        displayKey: displayKey,
        key: i,
        onRemove: onRemove
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SelectInputTags, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          selectedOptions = _props.selectedOptions,
          multiple = _props.multiple;

      if (!multiple) {
        return null;
      }
      return _react2.default.createElement(
        'ul',
        { className: 'SelectInputTags' },
        selectedOptions.map(this.renderSelectedOption)
      );
    }
  }]);

  return SelectInputTags;
}(_react.PureComponent);

SelectInputTags.propTypes = {
  selectedOptions: _propTypes2.default.array.isRequired,
  stylingKey: _propTypes2.default.string,
  displayKey: _propTypes2.default.string.isRequired,
  onRemove: _propTypes2.default.func.isRequired
};

SelectInputTags.defaultProps = {
  displayKey: 'text'
};

exports.default = SelectInputTags;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/FormInputs/Select/SelectInputTags.js
// module id = 544
// module chunks = 0